export const I18n = {
	'en': {
		title: 'Market',
		searchPlaceholder: 'Search...',
		selected: 'Selected',
		companyMarket: 'Company Market',
		downloadApk: {
			title: 'Upload Apk',
			submit: 'Upload',
			cancel: 'Cancel'
		},
		checkedAppsList: {
			title: 'Selected apps'
		},
		application: {
			title: 'Application'
		}
	},
	'ru': {
		title: 'Маркет приложений',
		searchPlaceholder: 'Поиск...',
		selected: 'Выбранные',
		companyMarket: 'Маркет Компании',
		downloadApk: {
			title: 'Загрузить AПК',
			submit: 'Загрузить',
			cancel: 'Отмена'
		},
		checkedAppsList: {
			title: 'Выбранные приложения'
		},
		application: {
			title: 'Приложение'
		}
	},
	'sk': {
		title: 'Trhové',
		searchPlaceholder: 'Vyhľadávanie...',
		selected: 'Vybraný',
		companyMarket: 'Market Company',
		downloadApk: {
			title: 'Nahrať súbor APK',
			submit: 'Nahrať',
			cancel: 'Zrušiť'
		},
		checkedAppsList: {
			title: 'Vybrané aplikácie'
		},
		application: {
			title: 'Prihláška'
		}
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/market/index.js